import { IonHeader, IonToolbar, IonTitle } from "@ionic/react"

export const mk_ion_header = ( title: string, size?: 'large'|'small', second_line: any = null ) =>
  {
    return (
      <IonHeader
        data-sf="mk_ion_header"
        style = { { backgroundColor: 'white', position: 'sticky', top: '0px', zIndex: 10 } }
      >
        <IonToolbar>
          <IonTitle size={ size }>{title}</IonTitle>
        </IonToolbar>
        { second_line }
      </IonHeader>
    ) ;
  }
